import React, { useContext } from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@clientbase/clientbase-library'
import { Box, Typography } from '@mui/material'

import { formatMetadataValue } from 'utils/format-metadata-value'

import { theme } from 'styles/theme'

import { ModalChargeDetailContext } from '../../context'
import { cardTittle } from '../../ModalChargeDetail.utils'
import { S } from '../BillingDetails'

const InternalIdentifier: React.FC = () => {
  const { invoice } = useContext(ModalChargeDetailContext)

  if (!Object.keys(invoice.metadata).length) {
    return null
  }

  return (
    <Accordion
      sx={{
        border: '1px solid #E8EBE8',
        borderLeft: '3px solid',
        borderLeftColor: 'primary.main',
        borderRadius: '8px !important',
        backgroundColor: '#FAFBFA',
        boxShadow: 'none',
        '&:before': { display: 'none' },
        '&.Mui-expanded': {
          margin: 0,
          backgroundColor: '#fff'
        }
      }}
    >
      <AccordionSummary>
        {cardTittle(
          'Identificador interno',
          'bookmark',
          `${theme.palette.primary.main}`
        )}
      </AccordionSummary>
      <AccordionDetails>
        {Object.keys(invoice?.metadata).map((field) => (
          <>
            <div>
              <Box
                display="flex"
                gap={1.25}
                alignItems="end"
                margin="10px 0px 10px 0px"
              >
                <Typography variant="smLight" color="#777777">
                  Nome do campo:
                </Typography>
                <S.Separator />
                <Typography variant="smBold">{field}</Typography>
              </Box>
            </div>
            <div>
              <Box
                display="flex"
                gap={1.25}
                alignItems="end"
                margin="10px 0px 10px 0px"
              >
                <Typography variant="smLight" color="#777777">
                  Informação:
                </Typography>
                <S.Separator />
                <Typography variant="smBold">
                  {formatMetadataValue(invoice?.metadata[field])}
                </Typography>
              </Box>
            </div>
          </>
        ))}
      </AccordionDetails>
    </Accordion>
  )
}

export default InternalIdentifier
